export default __webpack_public_path__ + "static/media/ic_olympus_arbitrum.b358dc93.svg";